export default __webpack_public_path__ + "static/media/i_pill_success.a30e2799.svg";